const totalSteps = ({ steps }) => {
  return steps.length;
};

const completedSteps = ({ completed }) => {
  return Object.keys(completed).length;
};

export const isLastStep = ({ activeStep, steps }) => {
  return activeStep === totalSteps({ steps }) - 1;
};

const allStepsCompleted = () => {
  return completedSteps() === totalSteps();
};

const handleNext = ({ completed, activeStep, setActiveStep, steps }) => {
  const newActiveStep =
    isLastStep({ steps }) && !allStepsCompleted()
      ? steps.findIndex((step, i) => !(i in completed))
      : activeStep + 1;

  setActiveStep(newActiveStep);
};

export const handleBack = ({ setActiveStep }) => {
  setActiveStep((prevActiveStep) => {
    return prevActiveStep - 1;
  });
};

export const handleStep =
  ({ step, setActiveStep }) =>
  () => {
    setActiveStep(step);
  };

export const handleComplete = ({
  steps,
  completed,

  activeStep,
  setActiveStep,
  setCompleted,
}) => {
  const newCompleted = completed;
  newCompleted[activeStep] = true;
  setCompleted(newCompleted);
  handleNext({ completed, activeStep, setActiveStep, steps });
};
